import { get, apiPrefix } from './common';
import { webApiResponseHandler } from './api';
const getJobRun = (type) => get(`${apiPrefix}/JobRun?type=${type}`).then(webApiResponseHandler);
const getJobRunById = (id) => get(`${apiPrefix}/JobRun/${id}`).then(webApiResponseHandler);
const getJobRunExpRptErrors = () => get(`${apiPrefix}/JobRun/JobRunExpRptErrors`).then(webApiResponseHandler);
const getJobRunResultById = (id) => get(`${apiPrefix}/JobRun/${id}/JobRunResult`).then(webApiResponseHandler);
export { getJobRun, getJobRunById, getJobRunExpRptErrors, getJobRunResultById };
